import React from 'react';
//Material-ui
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import RemoveIcon from '@material-ui/icons/RemoveCircle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
//react-phone-number-input
import 'react-phone-number-input/style.css';
import { isValidPhoneNumber } from 'react-phone-number-input';
import PhoneInput from 'react-phone-number-input';

function PhoneNumbers({
  getUserFullName,
  getUserPhoneNumber,
  handlePhone,
  handleRemove,
  members,
  phone,
}) {
  return (
    <Paper className="general-paper">
      <Typography variant="body1">Números Registrados</Typography>
      <br />
      <Grid container>
        <Grid item xs={12} sm={4}>
          <PhoneInput
            autoComplete="off"
            defaultCountry="MX"
            error={
              isValidPhoneNumber(phone) || phone === ''
                ? ''
                : 'Número de teléfono no valido'
            }
            onChange={(phone) => handlePhone(phone)}
            placeholder="Añadir Número"
            value={phone}
          />
        </Grid>
        {members.length > 0 ? (
          <Grid item xs={12}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Integrante</TableCell>
                  <TableCell align="right">Eliminar</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {members.map((member, i) => {
                  const phoneNumber = isValidPhoneNumber(member)
                    ? member
                    : getUserPhoneNumber(member);
                  const name = isValidPhoneNumber(member)
                    ? ''
                    : isValidPhoneNumber(getUserFullName(member))
                    ? ''
                    : getUserFullName(member);
                  return (
                    <TableRow key={i}>
                      <TableCell align="left">
                        {
                          <div>
                            <Typography variant="caption">{name}</Typography>
                            <Typography variant="caption">
                              {phoneNumber}
                            </Typography>
                          </div>
                        }
                      </TableCell>
                      <TableCell
                        align="right"
                        onClick={() => handleRemove(i, 'members')}
                      >
                        <IconButton aria-label="Borrar teléfono">
                          <RemoveIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        ) : null}
      </Grid>
    </Paper>
  );
}

export default PhoneNumbers;
